import { gql } from '@apollo/client';

export const RELATIONSHIP_FRAGMENT = gql`
  fragment relationshipFields on Relationship {
    id
    channel
    created
    email
    state
    uuid
    mainUser {
      emails
    }
    user {
      familyAccess
      mainUserAccess
    }
  }
`;